import {HEADER_HEIGHT} from "../../../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import PropTypes from 'prop-types';
import {Pagination, Table, Divider} from "antd";
import React from "react";
import BaseComponent from "../../../../base/BaseComponent";


export default class PageTableComponent extends BaseComponent {
    static defaultProps = {
        rowSelection: '',
        columns: [],//表格头部
        data: [],//数据源
        page: 1,//第几页
        size: 10,//一页10条数据
        count: 0,//总数
        onChangePage: () => {

        },
    };

    static propTypes = {
        // rowSelection:,
        columns: PropTypes.array.isRequired,//表格头部
        data: PropTypes.array.isRequired,//数据源
        page: PropTypes.number.isRequired,//第几页
        size: PropTypes.number.isRequired,//一页10条数据
        count: PropTypes.number.isRequired,//总数
        onChangePage: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT-186;
        if (this.props.positionHeight) {
            height = document.body.clientHeight - HEADER_HEIGHT -186- this.props.positionHeight;
        }
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return (
            <div className="cm-table-body" style={{marginTop: "24px"}}>
                <Scrollbars autoHeight
                            autoHide
                            autoHeightMax={this.props.count ? height : height + 112}
                            >
                    <Table
                        // style={{height: height}}
                        className={"tabList"}
                        rowClassName={this.getRowClassName}
                        rowSelection={this.props.rowSelection?this.props.rowSelection:null}
                        rowKey={this.props.rowKey?this.props.rowKey:'id'} pagination={false}
                        agination columns={this.props.columns} dataSource={this.props.data}/>
                </Scrollbars>
                {/*分页*/}
                {this.props.count > 0? <Divider style={{margin: '10px 0px 0px 0px'}}/>: null}
                {this.props.count > 0 ?<div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        position: 'relative',
                        height:'32px',
                        margin:'16px 0px 0px 0px'

                    }} className={'MyUploadStyle'}>
                        <Pagination

                            showQuickJumper
                            showSizeChanger
                            current={this.props.page}
                            pageSize={this.props.size}
                            total={this.props.count}
                            showTotal={total => `共 ${total} 条`}
                            onChange={(page, pageSize) => this.props.onChangePage && this.props.onChangePage(page, pageSize)}
                            onShowSizeChange={(page, pageSize) => {
                                this.props.onChangePage && this.props.onChangePage(page, pageSize)
                            }}
                        />
                    </div>: null}

                <style>
                    {
                        `.ant-checkbox-indeterminate .ant-checkbox-inner::after {background-color: ${newSecondSelectColor}}`
                    }
                </style>
            </div>
        )

    }

    //表格行背景色
    getRowClassName = (record, index) => {
        let className = '';
        className = index % 2 === 0 ? "evenRow" : "oddRow";
        return className;
    };

}